var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{ref:"gameIframe",staticClass:"iframe-box",attrs:{"id":"gameIframe","title":"Game Server Iframe","src":_vm.iframeSrc,"allow":"fullscreen;camera;xr-spatial-tracking;autoplay","allowusermedia":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }